<app-menu [hasChanges]="loadMenu" title="Cancelación de Ventas"></app-menu>
<app-loading [show]="load"></app-loading>
<div class="p-fluid pl-2 minScreen">
    <div class="grid m-3">
        <div class="col-12">
            <div class="p-inputgroup w-full">
                <p-inputNumber buttonLayout="horizontal" spinnerMode="horizontal" class="w-full"
                    [(ngModel)]="idComprobante" placeholder="Digite el número de venta">
                </p-inputNumber>
                <button pButton label="Buscar" icon="pi pi-search" class="p-button p-button-success"
                    (click)="getDetalleVenta()"></button>
            </div>
        </div>
    </div>
    <div class="grid" *ngIf="listBuy.length > 0">
        <div class="col-12 grid hidden md:flex" style="height: 55px;">
            <!-- Headers -->
            <div class="col-12 md:col-2 text-center">
                <h4>Imagen</h4>
                <!-- Imagen -->
                <img src="" alt="">
            </div>
            <div class="col-12 md:col-4 text-center">
                <h4>Producto</h4>
                <!-- Descripción -->
            </div>
            <div class="col-12 md:col-3 text-center">
                <h4>Cantidad</h4>
                <!-- Cantidad -->
            </div>
            <div class="col-12 md:col-3 text-center">
                <h4>$</h4>
            </div>
        </div>
        <div class="col-12">
            <p-divider></p-divider>
        </div>
        <div class="col-12 grid" *ngFor="let prod of listBuy; let index =index">
            <!-- Detalle -->
            <div class="col-12 md:col-2 align-self-start">
                <!-- Imagen -->
                <img src="" alt="">
            </div>
            <div class="col-12 md:col-4 align-self-start text-left">
                <p><b>{{prod.descripcionCorta}}</b><br>
                    <b>Código producto :</b> {{prod.referencia}}<br>
                    <b>Unidad de presentación :</b> {{prod.unidadPresentacion}}<br>
                    <b>Marca :</b> {{prod.marca}}<br>
                </p>
            </div>
            <div class="col-12 md:col-3 align-self-start">
                <span class="number">
                    <p-inputNumber [showButtons]="true" buttonLayout="horizontal" spinnerMode="horizontal"
                        decrementButtonClass="p-button-danger" incrementButtonClass="p-button-success" [min]="1"
                        [max]="100000" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"
                        [disabled]="true" [(ngModel)]="prod.cantidad">
                    </p-inputNumber>
                </span>
            </div>
            <div class="col-12 md:col-3 text-right">
                <!-- Precio Unitario-->
                <p><b>Precio:</b> {{(prod.precioProducto.precioPromocion > prod.precioProducto.precio ?
                    prod.precioProducto.precio: prod.precioProducto.precioPromocion ) | currency}}
                </p>
                <!-- Subtotal-->
                <p><b>Subtotal:</b> {{prod.cantidad * (prod.precioProducto.precioPromocion >
                    prod.precioProducto.precio ? prod.precioProducto.precio:
                    prod.precioProducto.precioPromocion ) | currency}}</p>
                <p><b>Impuesto:</b> {{prod.impuesto | currency}}</p>
                <!-- Valor Total -->
                <p><b>Valor Total:</b> {{(prod.cantidad * (prod.precioProducto.precioPromocion >
                    prod.precioProducto.precio ? prod.precioProducto.precio:
                    prod.precioProducto.precioPromocion)) +
                    (prod.impuesto)| currency}}</p>
            </div>
            <div class="col-12">
                <p-divider></p-divider>
            </div>
        </div>
        <div class="col-12 flex card pr-3">
            <table class="mx-auto">
                <tr>
                    <td class="text-right">
                        <h3><b>Nro. Items:</b></h3>
                    </td>
                    <td class="text-center">
                        <h3>{{listBuy.length}}</h3>
                    </td>
                </tr>
                <tr>
                    <td class="text-right">
                        <h3><b>SubTotal:</b></h3>
                    </td>
                    <td class="text-center">
                        <h3>{{subtotal | currency}}</h3>
                    </td>
                </tr>
                <tr>
                    <td class="text-right">
                        <h3><b>Impuesto:</b></h3>
                    </td>
                    <td class="text-center">
                        <h3>{{impuesto | currency}}</h3>
                    </td>
                </tr>
                <tr>
                    <td class="text-right">
                        <h2><b>Total:</b></h2>
                    </td>
                    <td class="text-center">
                        <h2><b> {{(subtotal + impuesto) | currency}}</b> </h2>
                    </td>
                </tr>
            </table>
        </div>
        <div class="text-center w-full flex">
            <button pButton class="p-button p-button-danger" label="Volver" icon="pi pi-directions-alt"></button>&nbsp;
            <button pButton class="p-button p-button-success" label="Procesar cancelación" *ngIf="showBtn"
                icon="pi pi-times-circle" (click)="setCancelar()"></button>
        </div>
    </div>
</div>
<p-toast></p-toast>
<app-footer></app-footer>